import React from 'react'
import { Container } from '@components/Container'
import { AppLayout } from '@components/layouts/AppLayout'
import { BreadCrumb } from '@components/BreadCrumb'
import { BreadCrumbMenu } from '@components/BreadCrumb/interface'
import { OgShare } from '@components/OgShare'
import FaqMenu from '../components/FaqMenu'

export interface SubMenuPageProps {
  menus: { title: string; url: string }[]
  content: React.ReactNode
  breadCrumbList: BreadCrumbMenu[]
  url: string
}

function SubMenuPage({
  menus,
  content,
  breadCrumbList,
  url,
}: SubMenuPageProps) {
  return (
    <AppLayout>
      <OgShare url={url} />
      <Container>
        <BreadCrumb
          pageList={breadCrumbList}
          className='pt-[20px] tablet-mobile:px-[20px]'
        />
        <div className='faq pb-[50px] pt-[20px] tablet-mobile:pb-[20px] tablet:px-[20px] mobile:px-[10px]'>
          <div className='shadow-card rounded-[8px] px-[20px] pt-[20px] mobile:px-[10px] mobile:pt-[10px] flex flex-col font-mitr dark:text-dark-10'>
            {content ? (
              <div className='faq font-sarabun text-sm font-light pb-[20px] mobile:pb-[10px]'>
                {content}
              </div>
            ) : (
              <>
                {menus.map(menu => (
                  <FaqMenu key={menu.title} {...menu} />
                ))}
              </>
            )}
          </div>
        </div>
      </Container>
    </AppLayout>
  )
}

export default SubMenuPage
